import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseViewElement} from '../base-view-element';
import {PropertySet} from '../../../core/model/helper-models/property-set.model';
import {Property} from '../../../core/model/helper-models/property.model';

@Component({
    selector: 'app-finger-time',
    templateUrl: './finger-time.component.html',
    styleUrls: ['./finger-time.component.scss',
        './../card.scss'],
    standalone: false
})
export class FingerTimeComponent extends BaseViewElement implements OnInit, OnChanges
{
    @Input() Finger11: PropertySet;
    @Input() Finger12: PropertySet;
    @Input() Finger21: PropertySet;
    @Input() Finger22: PropertySet;
    @Input() Finger31: PropertySet;
    @Input() Finger32: PropertySet;

    TimeExtend11: Property<any>;
    TimeExtend12: Property<any>;
    TimeExtend21: Property<any>;
    TimeExtend22: Property<any>;
    TimeExtend31: Property<any>;
    TimeExtend32: Property<any>;

    TimeRetract11: Property<any>;
    TimeRetract12: Property<any>;
    TimeRetract21: Property<any>;
    TimeRetract22: Property<any>;
    TimeRetract31: Property<any>;
    TimeRetract32: Property<any>;

    constructor()
    {
        super('finger-time');
        this.chart = true;
    }

    onResize(result: any)
    {
        this.childResizeEvent.emit();
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Finger11 != null)
        {
            this.TimeExtend11 = this.Finger11.properties.get('TIME_EXTEND');
            this.TimeRetract11 = this.Finger11.properties.get('TIME_RETRACT');
        }
        if (this.Finger12 != null)
        {
            this.TimeExtend12 = this.Finger12.properties.get('TIME_EXTEND');
            this.TimeRetract12 = this.Finger12.properties.get('TIME_RETRACT');
        }
        if (this.Finger21 != null)
        {
            this.TimeExtend21 = this.Finger21.properties.get('TIME_EXTEND');
            this.TimeRetract21 = this.Finger21.properties.get('TIME_RETRACT');
        }
        if (this.Finger22 != null)
        {
            this.TimeExtend22 = this.Finger22.properties.get('TIME_EXTEND');
            this.TimeRetract22 = this.Finger22.properties.get('TIME_RETRACT');
        }
        if (this.Finger31 != null)
        {
            this.TimeExtend31 = this.Finger31.properties.get('TIME_EXTEND');
            this.TimeRetract31 = this.Finger31.properties.get('TIME_RETRACT');
        }
        if (this.Finger32 != null)
        {
            this.TimeExtend32 = this.Finger32.properties.get('TIME_EXTEND');
            this.TimeRetract32 = this.Finger32.properties.get('TIME_RETRACT');
        }
    }

}
